module.exports = __webpack_public_path__ + "img/dialog_ticket.af453420.svg";